module.exports = __webpack_public_path__ + "img/mimosa.11e8d5ef.png";